import React from 'react';
import { PayorDataItem } from '../../payor_list_types';
import utilSvc from '../../../../../core/utilSvc';
import { lightFormat } from 'date-fns';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ModifiedByRenderer = ({ item, colKey }: { item: PayorDataItem; colKey: string }): JSX.Element => {
    return (
        <>
            {item.ModifiedBy ? <p className="non-padded-text">{item.ModifiedBy}</p> : null}
            {utilSvc.dt.isValid(item.ModifiedDate) ? (
                <p className="non-padded-text">{lightFormat(item.ModifiedDate, utilSvc.dt.fmtMdyyyy)}</p>
            ) : null}
        </>
    );
};

export default ModifiedByRenderer;
